// import {useHistory} from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import {
	Button,
	Divider,
	Dropdown,
	Input,
	Menu,
	Pagination,
	Radio,
	Row,
	Spin,
} from "antd";

import longlifeApi from "../../apis/Longlife.api";
import CommentComponent from "../../components/comment/CommentComponent";
import LinkComponent from "../../components/layout/LinkComponent";
import UserManageNav from "../../components/userManageGroup/userManageNav";
import { setLoading } from "../../redux/store/common/commonDuck";

const MissionCommentManage = () => {
	// const history = useHistory();
	const dispatch = useDispatch();

	const user = useSelector((state) => state.auth.user);
	const isLoading = useSelector((state) => state.common.loading);
	const setIsLoading = (value) => dispatch(setLoading(value));

	const [dropdownOpen, setDropdownOpen] = useState(false);
	const [filterValue, setFilterValue] = useState(1);
	const [filterName, setFilterName] = useState("전체");
	const [filterSearch, setFilterSearch] = useState("");

	const [initialBool, setInitialBool] = useState(false);

	const [commentList, setCommentList] = useState([]);

	const pageSize = 5;
	// const [pageSize, setPageSize] = useState(5);
	const [currentPageNumber, setCurrentPageNumber] = useState(1);
	const [totalCount, setTotalCount] = useState(0);

	const [readLoading, setReadLoading] = useState(false);

	useEffect(() => {
		window.scrollTo({
			top: 0,
		});
	}, []);

	/**
	 * page 넘김
	 */
	const handleChangePagination = async (pageNumber) => {
		// const currOffset = (pageNumber - 1) * pageSize;
		setCurrentPageNumber(pageNumber);
	};

	useEffect(() => {
		getAdminCommentList();
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	}, [currentPageNumber]);

	const filterList = [
		{
			label: "전체",
			key: 0,
		},
		{
			label: "내가 응답하지 않은 댓글",
			key: 1,
		},
		{
			label: "내가 답변한 댓글",
			key: 2,
		},
		// {
		// 	label: "새 답글이 있는 댓글",
		// 	key: 3,
		// },
	];

	useEffect(() => {
		getAdminCommentList();
	}, []);

	/**
	 * 관리자용 댓글 가져오기
	 * @returns {Promise<void>}
	 */
	const getAdminCommentList = async (type) => {
		setIsLoading(true);
		setReadLoading(true);
		const param = {
			offset: (currentPageNumber - 1) * pageSize,
			pageSize: pageSize,
			influencerId:
				user?.role === "level_1" || user?.role === "super_admin"
					? user?.id
					: user?.partners_id,
			answerStatus: filterValue ?? 1,
			searchWord: filterSearch,
		};
		const res = await longlifeApi.adminReadVerification(param);
		if (res.code === 200) {
			setTotalCount(res.result.totalCommentCnt);
			setCommentList(res.result?.commentDTOList);
			setFilterName(
				filterList?.filter((item) => item.key === filterValue)?.[0]?.label
			);
		} else {
			setTotalCount(0);
			setCommentList([]);
		}
		if (type) {
			if (type === "filter") {
				setCurrentPageNumber(1);
			}
		}
		setIsLoading(false);
		setReadLoading(false);
	};

	/**
	 * 드롭다운 오픈
	 * @param e
	 */
	const handleOpenChange = (e) => {
		setDropdownOpen(e);
	};

	/**
	 * 드롭다운 선택
	 * @param item
	 */
	const dropdownSelect = (item) => {
		setFilterValue(item?.key);
	};

	/**
	 * dropdown items
	 * @type {JSX.Element}
	 */
	const dropdownItems = (
		<Menu className={`dropdown-comment-filter`}>
			<div className={`filter-title`}>
				<p>답변상태</p>
				<img
					src={`/assets/images/channel/close.png`}
					alt={`추가`}
					style={{
						width: "1.2em",
						height: "1.2em",
						cursor: "pointer",
					}}
					onClick={() => setDropdownOpen(false)}
				/>
			</div>
			{filterList?.map((item, idx) => (
				<Menu.Item key={`filter-${idx}`} onClick={() => dropdownSelect(item)}>
					<Radio value={item.key} checked={item.key === filterValue}>
						{item.label}
					</Radio>
				</Menu.Item>
			))}
			<Divider plain style={{ margin: "0.5em 0 0" }} />
			<Row justify={"end"}>
				<Button
					className={`dropdown-filter-apply-button`}
					onClick={() => {
						getAdminCommentList("filter");
						setDropdownOpen(false);
					}}
				>
					적용
				</Button>
			</Row>
		</Menu>
	);

	/**
	 * 필터 초기화
	 */
	const handleFilterInitialize = () => {
		setFilterValue(1);
		setFilterName("내가 응답하지 않은 댓글");
		setFilterSearch("");
		if (currentPageNumber === 1) {
			setInitialBool(true);
		} else {
			setCurrentPageNumber(1);
		}
	};

	useEffect(() => {
		if (initialBool) {
			getAdminCommentList();
			setInitialBool(false);
		}
	}, [initialBool]);

	return (
		<div className="main-wrap">
			<div className="max-width-apply">
				<LinkComponent />

				<h1 className="main-title">회원 관리</h1>

				<UserManageNav />

				<Row className={`comment-filter`}>
					<p>필터</p>
					{/* 필터 드롭다운 */}
					<Dropdown
						overlay={dropdownItems}
						trigger={["click"]}
						open={dropdownOpen}
						onOpenChange={handleOpenChange}
						overlayClassName={`comment-filter-dropdown-box`}
					>
						<Button className={`comment-filter-dropdown`}>
							<p>응답상태</p>
							<p>
								{filterName}
								<img
									src={`/assets/images/report/down.png`}
									alt={`드롭다운`}
									style={{
										width: "1em",
										height: "1em",
										marginLeft: "3px",
									}}
								/>
							</p>
						</Button>
					</Dropdown>

					{/* 필터 검색 */}
					<Input.Search
						addonBefore="검색"
						type={`text`}
						className={`comment-filter-input-search ${
							filterSearch?.length > 0 ? "search-ing" : ""
						}`}
						onSearch={() => {
							setCurrentPageNumber(1);
							getAdminCommentList();
						}}
						value={filterSearch}
						onChange={(e) => setFilterSearch(e.target.value)}
					/>

					{/* 필터 초기화*/}
					<button
						className={`initialize-filter`}
						onClick={handleFilterInitialize}
					>
						<img
							src={`/assets/images/report/refresh.png`}
							alt={`초기화`}
							style={{
								width: "1em",
								height: "1em",
							}}
						/>
						필터 초기화
					</button>
				</Row>

				{/* 댓글 관리 */}
				{isLoading && !commentList?.length && (
					<Spin
						style={{
							margin: "auto",
							width: "100%",
							paddingTop: "10em",
							position: "absolute",
							left: 0,
							right: 0,
						}}
					/>
				)}

				{commentList?.length > 0 ? (
					<div className={`main-body`} style={{ padding: 0 }}>
						{commentList?.map((comment, idx) => (
							<div
								className={`comment-manage-body`}
								key={`comment-list-${idx}`}
								style={{ position: "relative" }}
							>
								<CommentComponent
									comment={comment}
									getAdminCommentList={getAdminCommentList}
									setReadLoading={setReadLoading}
									totalCount={totalCount}
									currentPageNumber={currentPageNumber}
									setCurrentPageNumber={setCurrentPageNumber}
								/>
								{readLoading && (
									<div
										style={{
											position: "absolute",
											top: 0,
											bottom: 0,
											left: 0,
											right: 0,
											backgroundColor: "rgba(0,0,0,0.1)",
											display: "flex",
											justifyContent: "center",
											alignItems: "center",
											zIndex: 9,
										}}
									>
										<Spin />
									</div>
								)}
							</div>
						))}
						<Pagination
							className="report-pagination-wrap"
							showSizeChanger={false}
							current={currentPageNumber}
							pageSize={pageSize}
							total={totalCount}
							onChange={handleChangePagination}
						/>
					</div>
				) : (
					<Row
						align={"middle"}
						style={{
							width: "100%",
							flexDirection: "column",
							padding: "5em 0",
						}}
					>
						<img
							src={`/assets/images/warning.png`}
							alt={`warning-icon`}
							style={{
								width: "3em",
								height: "auto",
							}}
						/>
						<p
							style={{
								marginTop: "1em",
								color: "#adb5bd",
								fontSize: "1.1em",
								fontWeight: 500,
							}}
						>
							등록된 댓글이 없습니다.
						</p>
					</Row>
				)}
			</div>
		</div>
	);
};
export default MissionCommentManage;
